import React from 'react';
import SwitchRoundFlag from './SwitchRoundFlag';
var selfStyles = require('./SwitchRoundFlag.scss');
var SwitchRoundFlagVisible = function (props) { return (React.createElement(SwitchRoundFlag, { round: props.round, field: 'isScoresVisible', handlePatchRound: props.handlePatchRound, confirmMessageSetTrue: (React.createElement("div", { className: selfStyles.popconfirm },
        React.createElement("h3", null, "Publish scores for round?"),
        React.createElement("p", null, "This will publish the scoreboard for this round to the public"))), confirmMessageSetFalse: (React.createElement("div", { className: selfStyles.popconfirm },
        React.createElement("h3", null, "Unpublish scores for round?"),
        React.createElement("p", null, "This will hide the scoreboard for this round from the public"))) })); };
export default SwitchRoundFlagVisible;



//////////////////
// WEBPACK FOOTER
// ./src/pages/WorkspaceEvent/ListRoundPage/SwitchRoundFlagVisible.tsx
// module id = 239
// module chunks = 0